const _intervals = {
  '1hr': 60 * 60,
  '12hour': 60 * 60 * 12,
  day: 60 * 60 * 24,
  week: 60 * 60 * 24 * 7,
  month: 60 * 60 * 24 * 30,
  '3month': 60 * 60 * 24 * 30 * 3,
  alltime: 60 * 60 * 24 * 365 * 5
};
export const resolutionData = [{
  timeFrame: 'hour',
  periodLabel: '1H'
}, {
  timeFrame: 'day',
  periodLabel: '1D'
}, {
  timeFrame: 'week',
  periodLabel: '1W'
}, {
  timeFrame: 'month',
  periodLabel: '1M'
}, {
  timeFrame: '3month',
  periodLabel: '3M'
}, {
  timeFrame: 'alltime',
  periodLabel: '1Y'
}, {
  timeFrame: 'alltime',
  periodLabel: 'ALL'
}];
export const assetResolutionData = [{
  timeFrame: '1hr',
  periodLabel: 'LIVE',
  resolution: '1',
  interval: _intervals['1hr']
}, {
  timeFrame: '12hour',
  periodLabel: '12H',
  resolution: '1',
  interval: _intervals['12hour']
}, {
  timeFrame: 'day',
  periodLabel: '1D',
  resolution: '1',
  interval: _intervals['day']
}, {
  timeFrame: 'week',
  periodLabel: '1W',
  resolution: '15',
  interval: _intervals['week']
}, {
  timeFrame: 'month',
  periodLabel: '1M',
  resolution: '1D',
  interval: _intervals['month']
}, {
  timeFrame: '3month',
  periodLabel: '3M',
  resolution: '1D',
  interval: _intervals['3month']
}, {
  timeFrame: 'alltime',
  periodLabel: 'ALL',
  resolution: '7D',
  interval: _intervals['alltime']
}];